import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseLoopBackApiService } from '../base.service';

@Injectable()
export class UploadLoopBackApiService extends BaseLoopBackApiService {
  modelName = 'Uploads';

  public upload(container: any, data: any = null): Observable<any> {
    let options = {
      headers: {'Content-Type': null},
      pathUrl: ':container/upload',
      urlParams: { container: container },
      body: data
    };

    return this.post(options);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/api/loopback/custom/upload.service.ts